import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Container, Stack, TextField, Typography } from '@mui/material';
import MealPlansContext from '../../context/meal-plans-context';

const NewMealPlanPage = () => {
  const { createPlan } = useContext(MealPlansContext);
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;

    setSaving(true);
    setError(null);
    try {
      const plan = await createPlan(name.trim(), dueDate || undefined);
      navigate(`/meal-plan/${plan.id}`);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 2 }}>
      <Typography variant="h5" sx={{ mb: 3 }}>
        Nový jídelní plán
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Stack component="form" onSubmit={handleSubmit} spacing={2}>
        <TextField
          label="Název plánu"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          required
          autoFocus
          inputProps={{ maxLength: 180 }}
        />
        <TextField
          label="Termín (volitelné)"
          type="date"
          value={dueDate}
          onChange={(e) => setDueDate(e.target.value)}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
        <Stack direction="row" spacing={2}>
          <Button type="submit" variant="contained" disabled={saving || !name.trim()}>
            {saving ? 'Vytvářím...' : 'Vytvořit plán'}
          </Button>
          <Button onClick={() => navigate('/meal-plans')} disabled={saving}>
            Zrušit
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
};

export default NewMealPlanPage;
